import { User } from "@/types";
import { IDataProvider } from "@/store";

export interface IUserState {
  user: User | null;
  profile: User | null;
  users: User[] | null;
  dataProvider: IDataProvider<User>;
}

export const state: IUserState = {
  user: null,
  profile: null,
  users: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
